import { IActionFromBackend } from '@app/@types/scenes/scenes'

const getShowAndStringValue = (array: Array<IActionFromBackend>,
  index: number): boolean => (array.length > 1 && index !== (array.length - 1))

export default getShowAndStringValue
